// components/seating-chart/SeatingChartSectionShape.js — v4
//
// Fix: the outer <Group> never had an explicit width/height, so Konva's
// node.width()/height() returned 0 for it (Group does NOT auto-compute from
// children unless you call getClientRect() explicitly). onTransformEnd's
// `node.width() * node.scaleX()` was therefore always ~0, clamped to the
// Math.max(40, ...) floor — that's the "collapses into a small square and
// gets stuck" bug. Setting width/height explicitly on the Group fixes it.
// Also: chip background is now a translucent overlay instead of a hardcoded
// hex, so it blends with whatever the actual canvas background is.

import React from "react";
import { Group, Rect, Text } from "react-konva";

const SeatingChartSectionShape = ({
  section,
  isSelected,
  isFocused,
  draggable,
  shapeRefs,
  onSelect,
  onOpen,
  onDragStart,
  onDragMove,
  onDragEnd,
  onTransformEnd,
}) => {
  return (
    <Group
      x={section.x}
      y={section.y}
      width={section.width}
      height={section.height}
      rotation={section.rotation}
      draggable={draggable}
      onClick={(e) => onSelect(e, section.id)}
      onDblClick={onOpen}
      onDragStart={onDragStart}
      onDragMove={onDragMove}
      onDragEnd={(e) => {
        const dx = e.target.x() - section.x;
        const dy = e.target.y() - section.y;
        onDragEnd(dx, dy, section.id);
      }}
      onTransformEnd={(e) => onTransformEnd(e, section.id)}
      ref={(node) => {
        if (shapeRefs?.current) shapeRefs.current[section.id] = node;
      }}
    >
      <Rect
        width={section.width}
        height={section.height}
        fill="rgba(255,255,255,0.03)"
        stroke={isFocused ? "#00C853" : isSelected ? "#007AFF" : "#555"}
        strokeWidth={isFocused || isSelected ? 2 : 1}
        dash={isFocused ? undefined : [6, 4]}
        cornerRadius={6}
      />
      <Rect x={0} y={-24} width={Math.min(140, section.width)} height={20} fill="transparent" cornerRadius={4} listening={false} />
      <Text
        text={section.name}
        x={6}
        y={-22}
        width={Math.min(128, section.width - 12)}
        fill="white"
        fontSize={12}
        listening={false}
      />
    </Group>
  );
};

export default React.memo(SeatingChartSectionShape);